import { Grid, styled, Typography } from "@mui/material";

export const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "hasImage",
})<{ hasImage: boolean }>(({ hasImage }) => ({
  textAlign: hasImage ? "justify" : "center",
  padding: "0 10px",
}));

export const Title = styled(Typography)({
  width: "100%",
  textAlign: "center",
  margin: "2.5rem 0",
}) as typeof Typography;

export const Content = styled("div", {
  shouldForwardProp: (prop) => prop !== "reverse",
})<{ reverse: boolean }>(({ theme, reverse }) => ({
  display: "flex",
  flexDirection: reverse ? "row" : "row-reverse",
  alignItems: "stretch",
  gap: "1rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const Description = styled("div")({
  flex: 1,
  minWidth: 0,
  "& > :first-child": { marginTop: 0 },
  "& > :last-child": { marginBottom: 0 },
});

export const ImageContainer = styled("div")(({ theme }) => ({
  position: "relative",
  flex: "0 0 40%",
  minWidth: 0,
  borderRadius: "10px",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    flex: "none",
    aspectRatio: "16 / 9",
  },
}));

// Keep the image's intrinsic size from determining the content row's height.
export const Image = styled("img")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
});
